import { Component, input } from '@angular/core';
import { RealEstate } from '../../models/real-estate.model';

@Component({
  selector: 'app-property-list',
  standalone: false,
  templateUrl: './property-list.component.html',
  styleUrl: './property-list.component.scss',
})
export class PropertyListComponent {
  properties = input<RealEstate[] | null>(null);
  listId = input<string>('propertyList');
}
